import React, { useEffect, useState, useContext } from 'react';
import { Card, Row, Col, message, Spin, Typography } from 'antd';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { SucursalContext } from '../../../context/sucursalContext';

const { Title, Text } = Typography;

const CSeleccionSucursal = () => {
    const [sucursales, setSucursales] = useState([]);
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();
    const { sucursal, seleccionarSucursal } = useContext(SucursalContext);

    useEffect(() => {
        if (sucursal) {
            navigate('/home');
            return;
        }

        const fetchSucursales = async () => {
            try {
                const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/sucursal/empresa`);
                setSucursales(data);
            } catch (error) {
                message.error('Error al cargar las sucursales');
            } finally {
                setLoading(false);
            }
        };

        fetchSucursales();
    }, [sucursal]);


    const handleSeleccion = (suc) => {
        seleccionarSucursal(suc);
        navigate('/home');
    };

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 100 }}>
                <Spin size="large" />
            </div>
        );
    }

    return (
        <div style={{ padding: '40px 20px', minHeight: '100vh', background: '#f9f9f9' }}>
            <Title level={2} style={{ textAlign: 'center', marginBottom: 40 }}>
                Seleccioná una sucursal
            </Title>
            <Row gutter={[24, 24]} justify="center">
                {sucursales.map((suc) => (
                    <Col xs={24} sm={12} md={8} lg={6} key={suc.suc_id}>
                        <Card
                            hoverable
                            onClick={() => handleSeleccion(suc)}
                            style={{
                                borderRadius: 12,
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                                transition: 'transform 0.2s',
                                textAlign: 'center',
                            }}
                            bodyStyle={{ padding: 20 }}
                        >
                            <Title level={4} style={{ color: '#01634C' }}>{suc.suc_nombre}</Title>
                            <Text>{suc.suc_direccion}</Text>
                            <br />
                            <Text type="secondary">{suc.suc_telefono}</Text>
                        </Card>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default CSeleccionSucursal;